export default __webpack_public_path__ + "3d34868e253bc04aed7f99e37e88afe2.svg";